// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/vuejs_code_split/" + chunkId + ".js?id=" + {"756":"9b99bb283f9b8710","856":"4395e4ce80e02361"}[chunkId] + "";
};